var XMLNode = require('../xml/XMLNode');

/**
 * The NumberFormat class is used to store custom formatting for
 * numeric values. In addition to a variety of built-in formats that
 * cannot be used as identifier for a particular format, the user can
 * create up to 250 different number formats.
 *
 * (https://support.office.com/en-us/article/Excel-specifications-and-limits-1672b34d-7043-467e-8e27-269d656771c3)
 *
 * @param {Object} oData - Configuration object that is used for initialization
 * @param {string} oData.format - Custom format that will be applied
 * @constructor
 */
function NumberFormat(oData) {
	XMLNode.call(this, NumberFormat.metadata);

	this.format.value = oData && oData.format ? oData.format : NumberFormat.DEFAULT;
}

NumberFormat.prototype = Object.create(XMLNode.prototype);
NumberFormat.prototype.constructor = NumberFormat;

NumberFormat.metadata = {
	tag: 'numFmt',
	attributes: [
		{
			id: 'formatId',
			name: 'numFmtId'
		},
		{
			id: 'format',
			name: 'formatCode'
		}
	]
};

NumberFormat.BUILTIN_IDS = [ 0, 1, 2, 3, 4, 9, 10, 11, 12, 13, 14, 15,
	16, 17, 18, 19, 20, 21, 22, 37, 38, 39, 40, 45, 46, 47, 48, 49 ];
NumberFormat.ID_OFFSET = 166;
NumberFormat.DEFAULT = '#,##0.00';

/**
 * This method returns the ID of this NumberFormat. If there was no
 * ID assigned yet, it will return undefined.
 *
 * @returns {number} - The ID of this NumberFormat
 */
NumberFormat.prototype.getId = function() {
	return this.formatId.value;
};


/**
 * Returns the format of this NumberFormat as a string.
 *
 * @returns {string} - The format template that gets applied
 */
NumberFormat.prototype.getFormat = function() {
	return this.format.value;
};


/**
 * Assigns the provided ID to the current NumberFormat.
 *
 * @param {number|string} sId - The ID of this NumberFormat that can be referenced
 */
NumberFormat.prototype.setId = function(sId) {
	var iId = typeof sId === 'number' ? sId : parseInt(sId, 10);

	/* Checks if NaN, below zero or builtin ID */
	if (isNaN(iId) || iId < 0 || NumberFormat._isBuiltin(iId)) {
		return;
	}

	this.formatId.value = sId;
};


/**
 * Sets a specific format.
 *
 * @param {string} sFormat - The format that gets applied by this NumberFormat
 */
NumberFormat.prototype.setFormat = function(sFormat) {
	this.format.value = sFormat;
};


/**
 * Checks if a given ID is a builtin ID or not. Builtin IDs cannot be used for custom NumberFormats.
 *
 * @param {number} iId - ID that needs to be checked if it is a builtin ID
 *
 * @returns {boolean} - Returns true if the provided ID is a builtin ID that cannot be used
 * @private
 */
NumberFormat._isBuiltin = function(iId) {
	return NumberFormat.BUILTIN_IDS.indexOf(iId) > -1;
};


/**
 * Compares another NumberFormat to the current one. This method will
 * match NumberFormat objects by its format regardless of their ID.
 *
 * @param {NumberFormat} oNumberFormat - The NumberFormat to compare with
 * @returns {boolean} - Returns true if the format template is equal to the one from the compared object
 */
NumberFormat.prototype.equals = function(oNumberFormat) {
	if (!(oNumberFormat instanceof NumberFormat)) {
		return false;
	}

	return this.getFormat() === oNumberFormat.getFormat();
};

module.exports = NumberFormat;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/style/NumberFormat.js
// module id = 35
// module chunks = 0